import React from "react";
import Sidebar from "../../../src/components/layout/Sidebar";
import CardContent from "../../components/ui/CardContent";

const DashboardTemplate = ({ children }) => {
  return (
    <div className="flex bg-[#F5F5F5] min-h-screen">
      {/* Sidebar */}
      <Sidebar />

      {/* Konten utama */}
      <div className="p-6 w-full">
        <CardContent>
          <div className="rounded-xl p-6 md:p-8 space-y-6">{children}</div>
        </CardContent>
      </div>
    </div>
  );
};

export default DashboardTemplate;
